var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconNameH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 529.76 81.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1165BA;}.cls-2{fill:none;stroke:#1165BA;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.58,65.45l4.88-6a27.49,27.49,0,0,0,19.34,7.5,18.11,18.11,0,0,0,6.84-1.13,9.57,9.57,0,0,0,4.14-3,6.66,6.66,0,0,0,1.4-4,7.77,7.77,0,0,0-1.27-4.32,12.73,12.73,0,0,0-4.44-3.79,50.19,50.19,0,0,0-8.93-3.74A57.27,57.27,0,0,1,116.9,41.7a16.71,16.71,0,0,1-6-5.8A13.93,13.93,0,0,1,109.19,29a14.16,14.16,0,0,1,2.57-8.24A18.05,18.05,0,0,1,119,14.86a24.25,24.25,0,0,1,10.63-2.22,30.17,30.17,0,0,1,10.55,2,31.48,31.48,0,0,1,9.58,5.58l-4.79,6.27a24,24,0,0,0-7.28-4.88A21.73,21.73,0,0,0,129,19.87q-5.84,0-8.76,2.48a7.46,7.46,0,0,0-2.92,5.8,6.47,6.47,0,0,0,1.18,3.66,11.63,11.63,0,0,0,4.14,3.35A50.14,50.14,0,0,0,131,38.52,49.07,49.07,0,0,1,143.26,44a20.32,20.32,0,0,1,6.54,6.45,14.18,14.18,0,0,1,2,7.27,15,15,0,0,1-2.52,8.45,17.36,17.36,0,0,1-7.37,6.11,27.69,27.69,0,0,1-11.8,2.26,33.52,33.52,0,0,1-8.76-1.18,38.05,38.05,0,0,1-8.24-3.22A28.67,28.67,0,0,1,106.58,65.45Z",
    transform: "translate(0 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.39,51.24A28,28,0,0,1,164,38.48a18.67,18.67,0,0,1,7.14-7.89,21.26,21.26,0,0,1,20.74,0A18.69,18.69,0,0,1,199,38.48a28.16,28.16,0,0,1,2.61,12.76A28.29,28.29,0,0,1,199,64a18.38,18.38,0,0,1-7.15,7.88,21.54,21.54,0,0,1-20.74,0A18.36,18.36,0,0,1,164,64,28.16,28.16,0,0,1,161.39,51.24Zm8.19,0A24,24,0,0,0,171,60.09a11.81,11.81,0,0,0,4.1,5.49,11.9,11.9,0,0,0,12.81,0A11.86,11.86,0,0,0,192,60.09a24,24,0,0,0,1.44-8.85A24,24,0,0,0,192,42.4a12.17,12.17,0,0,0-4.09-5.54,11.69,11.69,0,0,0-12.81,0A12.12,12.12,0,0,0,171,42.4,24,24,0,0,0,169.58,51.24Z",
    transform: "translate(0 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.85,56.3V28.76h8V55.25q0,6.11,2.66,8.89a9,9,0,0,0,6.84,2.79,13.17,13.17,0,0,0,6.71-1.87,25.27,25.27,0,0,0,6.1-5.1v6.27a24.7,24.7,0,0,1-6.71,6,16.17,16.17,0,0,1-16.12.31,13.77,13.77,0,0,1-5.49-6.06A22.77,22.77,0,0,1,213.85,56.3ZM244.7,73.64l-1.83-8.72V28.76h8V63c0,1.22,0,2.34.13,3.35s.25,2.17.48,3.44l.7,3.84Z",
    transform: "translate(0 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260,67.19l8.37-9.76a11.52,11.52,0,0,0,3.92,3.44,11,11,0,0,0,5.4,1.35,9.46,9.46,0,0,0,7.45-3c1.77-2,2.66-4.88,2.66-8.71v-37h13.94V52.29a22.25,22.25,0,0,1-3.18,12.16,20.57,20.57,0,0,1-8.54,7.62,26.8,26.8,0,0,1-11.89,2.62,24.66,24.66,0,0,1-10.11-2A26.2,26.2,0,0,1,260,67.19ZM273.55,24V13.51h23.53V24Z",
    transform: "translate(0 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.42,56.3V27.89h13.07v26.4q0,4.27,2.05,6.32a7.34,7.34,0,0,0,5.45,2,12,12,0,0,0,5.18-1.22,13.3,13.3,0,0,0,4.58-3.66v8.63a24.14,24.14,0,0,1-6.28,6,14.9,14.9,0,0,1-8.28,2.31,15.29,15.29,0,0,1-7.62-2,15.48,15.48,0,0,1-5.89-6.15A20.84,20.84,0,0,1,314.42,56.3ZM345.1,73.64l-1.66-8.72v-37h13.07V62.75c0,1.22,0,2.31.13,3.26s.25,2.08.48,3.36l.7,4.27Z",
    transform: "translate(0 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.27,27.89H381l1.65,8.71v37H369.58V38.78c0-1.22,0-2.31-.13-3.27s-.25-2.07-.48-3.35Zm13.08,15.86V35.12a23.1,23.1,0,0,1,6.4-6,15.56,15.56,0,0,1,8.41-2.31A15.58,15.58,0,0,1,409.89,35a20.47,20.47,0,0,1,2.31,10.24V73.64H399.13V47.23a10,10,0,0,0-1-4.75,6.3,6.3,0,0,0-2.74-2.74,8.86,8.86,0,0,0-4-.87,13.19,13.19,0,0,0-10,4.88Z",
    transform: "translate(0 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.87,14.73A7.4,7.4,0,0,1,426,9.46a7.65,7.65,0,0,1,10.8,0,7.39,7.39,0,0,1,2.09,5.27A7.4,7.4,0,0,1,436.77,20,7.68,7.68,0,0,1,426,20,7.41,7.41,0,0,1,423.87,14.73Zm1,58.91V27.89h13.08V73.64Z",
    transform: "translate(0 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.75,50.81A26.61,26.61,0,0,1,450.63,38a20.45,20.45,0,0,1,8-8.28,24.72,24.72,0,0,1,23.31,0A20.55,20.55,0,0,1,489.84,38a26.61,26.61,0,0,1,2.88,12.77,26.43,26.43,0,0,1-2.88,12.68,20.55,20.55,0,0,1-7.93,8.28,24.72,24.72,0,0,1-23.31,0,20.45,20.45,0,0,1-8-8.28A26.43,26.43,0,0,1,447.75,50.81Zm13.25,0a21.63,21.63,0,0,0,1.13,7.58,8.88,8.88,0,0,0,3.22,4.36,9.28,9.28,0,0,0,9.77,0,8.88,8.88,0,0,0,3.22-4.36,21.4,21.4,0,0,0,1.13-7.58,21.36,21.36,0,0,0-1.13-7.58,9.13,9.13,0,0,0-3.22-4.41,9.06,9.06,0,0,0-9.77,0,9.13,9.13,0,0,0-3.22,4.41A21.59,21.59,0,0,0,461,50.81Z",
    transform: "translate(0 -2.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.26,27.89H514L515.64,37v36.6H502.57V38.78c0-1.22-.05-2.31-.13-3.27s-.25-2.07-.48-3.35Zm13.07,17.17v-8.2A21.48,21.48,0,0,1,521,29.5a15.48,15.48,0,0,1,8.72-2.66v12.9a28,28,0,0,0-8.59,1.13A19.6,19.6,0,0,0,514.33,45.06Z",
    transform: "translate(0 -2.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 57.4,
    width: 22.82,
    height: 22.82,
    rx: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 28.67,
    y: 29.2,
    width: 22.82,
    height: 22.82,
    rx: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 56.81,
    y: 1,
    width: 22.82,
    height: 22.82,
    rx: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.67,
    y: 57.4,
    width: 22.82,
    height: 22.82,
    rx: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.81,
    y: 29.2,
    width: 22.82,
    height: 22.82,
    rx: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1,
    y: 29.2,
    width: 22.82,
    height: 22.82,
    rx: 4.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.67,
    y: 1,
    width: 22.82,
    height: 22.82,
    rx: 4.98
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconNameH);
export default __webpack_public_path__ + "static/media/logo-icon-name-h.3d52989bde162d3a2694b4dab88c4897.svg";
export { ForwardRef as ReactComponent };